import { FC, useEffect, useState } from 'react';
import { Modal } from 'taxaroo-ui';
import { AiAssistantPlanType } from '.';
import {
  basicModalTitle, chatOnlyModalTitle, defaultModalTitle, premiumModalTitle,
} from './ModalElements';
import AddonsModalContent from './AddonsModalContent';

type AddonsModalProps = {
  isModalVisible: boolean;
  closeModal: () => void;
  subscriptionCreated: (plan: AiAssistantPlanType) => void;
  subscriptionCancelled: () => void;
};

const AddonsModal: FC<AddonsModalProps> = ({
  isModalVisible,
  closeModal,
  subscriptionCreated,
  subscriptionCancelled,
}) => {
  const [modalTitle, setModalTitle] = useState<JSX.Element>();
  const [plan, setPlan] = useState<AiAssistantPlanType>();

  useEffect(() => {
    if (plan === 'AI VideoPlus') {
      setModalTitle(basicModalTitle);
    } else if (plan === 'AI VideoPro') {
      setModalTitle(premiumModalTitle);
    } else if (plan === 'AI Chat') {
      setModalTitle(chatOnlyModalTitle);
    } else {
      setModalTitle(defaultModalTitle);
    }
  }, [plan]);

  return (
    <Modal
      title={modalTitle}
      onCancel={() => closeModal()}
      visible={isModalVisible}
      width={1020}
      closable
      centered
      footer={null}
      bodyStyle={{ padding: '10px 20px', margin: 0 }}
    >
      <AddonsModalContent
        subscriptionCreated={subscriptionCreated}
        subscriptionCancelled={subscriptionCancelled}
        plan={plan}
        setPlan={setPlan}
      />
    </Modal>
  );
};

export default AddonsModal;
